import React, { useEffect } from 'react'
import logoutQueryString from 'src/utils/logoutQueryString'
import Footer from 'src/components/Footer/Footer'
import Navbar from 'src/components/Navbar/Navbar'
import LinesResearchContent from 'src/components/LinesResearchContent/LinesResearchContent'

const LinesResearchPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    logoutQueryString()
  }, [])

  return (
    <>
      <Navbar />
      <LinesResearchContent />
      <Footer />
    </>
  )
}

export default LinesResearchPage
